import { combineReducers } from 'redux';

import NewYorkSirsExport from './export/reducer';
import NewYorkSirsExportList from './exportlist/reducer';

export default combineReducers({
  NewYorkSirsExport,
  NewYorkSirsExportList,
});



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/state/reducer.js